import { gql } from "@apollo/client";

export const GET_BROADCASTER_CONFIG = gql`
  query GetBroadcasterConfig {
    getBroadcasterConfig {
      id
      userId
      isStreamStatsEnabled
      isSoundboardEnabled
      isDenyWarEnabled
      notificationDiscordId
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_BROADCASTER_CONFIG = gql`
  mutation UpdateBroadcasterConfig($input: UpdateBroadcasterConfigInput!) {
    updateBroadcasterConfig(input: $input) {
      id
      userId
      isStreamStatsEnabled
      isSoundboardEnabled
      isDenyWarEnabled
      notificationDiscordId
      createdAt
      updatedAt
    }
  }
`;
